import {
  fetchData,
  urls,
} from '@internal/backstage-plugin-dh-dock-shared-common';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';


export interface ownersProps {
  owners: any[];
  loading: boolean;
  error: string | null;
}


const initialState: ownersProps = {
  owners: [],
  loading: false,
  error: null,
};
export const fetchOwnersAsync = createAsyncThunk<any[], void>(
  'owners/fetchOwners',
  async () => {
    const response = await fetchData(urls.getAllProcessedOwners);
    return response; 
  },
);


export const ownerShipSlice = createSlice({
  name: 'owners',
  initialState,
  reducers: {},

  extraReducers: builder => {
    builder

      .addCase(fetchOwnersAsync.pending, state => {
        state.loading = true;
        state.error = null;
      })

      .addCase(
        fetchOwnersAsync.fulfilled,
        (state, action: PayloadAction<any[]>) => {
          state.owners = Array.isArray(action.payload) ? action.payload : [];
          state.loading = false;
        },
      )

      .addCase(fetchOwnersAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch owners';
      });
  },
});


export default ownerShipSlice.reducer;
